export default class Address {

    public navigated: KnockoutObservable<boolean>;

    private name: string;
    private isRestored: boolean;
    private parameters: any;
    private hiddenNames: Array<string>;

    constructor(private url?: string) {
        this.name = '';
        this.isRestored = false;
        this.parameters = {};
        this.hiddenNames = ['Filter', 'SerializedFilter'];

        this.navigated = ko.observable(false).extend({ notify: 'always' });

        if (url != null) {
            this.init();
        }
    }

    public onNavigated(navigatedCallback: (newValue: boolean) => void): void {
        if (navigatedCallback == null || typeof navigatedCallback != "function") {
            return;
        }

        this.navigated.subscribe(navigated => navigatedCallback(navigated));
    }

    public init(): void {
        if (_.isString(this.url)) {
            let split = this.url.split('/');
            this.name = split[split.length - 1];
        }

        if (!this.name) {
            this.name = 'Home';
        }

        if (this.name.indexOf('?') > -1) {
            let split = this.name.split('?');
            let uri = split[1];

            this.name = split[0];

            let nameValuePairs = uri.split('&');

            if (nameValuePairs.length > 0) {
                for (let i = 0; i < nameValuePairs.length; i++) {
                    let nameValuePairStr = nameValuePairs[i];
                    // let nameValuePair = nameValuePairStr.split('='); // funktioniert nicht, wenn in dem String ein '=' vorkommt
                    let eqIdx = nameValuePairStr.indexOf('=');
                    let key = nameValuePairStr.substring(0, eqIdx);
                    let val = nameValuePairStr.substring(eqIdx + 1);

                    // Filter werden meistens in einfachen Anf�hrungszeichen in die Adresse gelegt
                    // Notiz: decodeURIComponent/encodeURIComponent wird in diesem Projekt noch nicht verwendet
                    // Entspricht Spezialbehandlung aus SL-Code NavigationService.GetQueryStringParameterValue
                    if (key.toLowerCase() == 'filter' && val.length >= 2 && val.charAt(0) == "'" && val.charAt(val.length - 1) == "'") {
                        val = val.substring(1, val.length - 1);
                    }

                    try {
                        val = decodeURIComponent(val);
                    }
                    catch (e) {
                        // okay, wir haben eine URL bekommen, die % enth�lt, aber eigentlich gar nicht URI-encoded ist
                    }

                    this.parameters[key] = val;
                }
            }
        }
    }

    public getName(): string {
        return this.name + '';
    }

    public getIsRestored(): boolean {
        return this.isRestored;
    }


    public setName(parameter: string): void {
        this.name = parameter;
    }

    public getParameters(): any {
        return jQuery.extend(true, {}, this.parameters);
    }


    public getParameter(parameter: string): string {
        if (parameter in this.parameters) {
            return this.parameters[parameter];
        }
        else {
            return null;
        }
    }

    public setParameter(parameter: string, value: any): void {
        if (typeof value == 'function') {
            return;
        }

        this.parameters[parameter] = value;
    }

    public removeParameter(parameter: string): void {
        delete this.parameters[parameter];
    }

    public setParameters(list: any): void {
        if (_.isArray(list)) {
            for (let i = 0; i < list.length; i++) {
                this.setParameter(list[i].name, list[i].value);
            }
        }
        else {
            for (let name in list) {
                this.setParameter(name, list[name]);
            }
        }
    }

    public setHiddenParameter(parameter: string, value: any): void {
        this.setParameter(parameter, value);
        this.setHiddenName(parameter);
    }

    public setHiddenParameters(list: Array<any>): void {
        if (list == null) {
            return;
        }

        this.setParameters(list);
        this.setHiddenNames(list);
    }

    public getHiddenNames(): Array<string> {
        return this.hiddenNames.slice(0);
    }

    public setHiddenNames(names: Array<string | { name: string }> | { name: string }): void {
        if (names == null) {
            return;
        }

        if (_.isArray(names)) {
            for (let i = 0; i < names.length; i++) {
                let name = names[i];
                if (typeof name == 'string') {
                    this.setHiddenName(name);
                }
                else if (name != null && name.name != null && typeof name.name == 'string') {
                    this.setHiddenName(name.name);
                }
            }
        }
        else {
            for (let name in names) {
                this.setHiddenName(name);
            }
        }
    }

    public setHiddenName(name: string) {
        if (this.hiddenNames.indexOf(name) < 0) {
            this.hiddenNames.push(name);
        }
    }

    private getQueryString(onlyPublic: boolean): string {
        let result = '';

        if (_.keys(this.parameters).length > 0) {
            let parameterArray = [];

            _.each(this.parameters, (value: string, key: string) => {
                if (onlyPublic && this.hiddenNames.indexOf(key) >= 0) {
                    return;
                }

                if (value == null) {
                    return;
                }

                if (key.toLowerCase() == 'query' || key.toLowerCase() == 'titleextension') {
                    value = encodeURIComponent(value);
                }
                parameterArray.push(key + '=' + value);
            });

            result += '?' + parameterArray.join('&');
        }

        return result;
    }

    public getPublicURL(): string {
        let queryString = this.getQueryString(true);
        let result = this.name + queryString;

        return result;
    }

    public toString(): string {
        let queryString = this.getQueryString(false);
        let result = this.name + queryString;

        return result;
    }

    public hasHiddenParameter(): boolean {
        return this.hiddenNames.some((hiddenName) => {
            return this.parameters.hasOwnProperty(hiddenName);
        });
    }

    public equalsDeeply(address: Address): boolean {
        if (this.name !== address.getName()) {
            return false;
        }

        if (!_.isEqual(this.parameters, address.getParameters())) {
            return false;
        }

        if (!_.isEqual(this.hiddenNames, address.getHiddenNames())) {
            return false;
        }

        return true;
    }

    public isEqualTo(address: Address | Address[]): boolean {
        if (_.isArray(address)) {
            for (let i = 0; i < address.length; i++) {
                if (this.isEqualTo(address[i])) {
                    return true;
                }
            }

            return false;
        }
        else {
            let ad = address.getName();

            if (!this.name && !ad) {
                return true;
            }
            else if (!this.name && ad) {
                return false;
            }
            else if (this.name && !ad) {
                return false;
            }
            else {
                return this.name.toLowerCase() === ad.toLowerCase();
            }
        }
    }

    public clone(): Address {
        let address = new Address();
        address.setName(this.getName());
        address.setParameters(this.getParameters());
        address.setHiddenNames(this.getHiddenNames());
        return address;
    }

    public static restoreFromStorageAddress(obj: any) {
        let address = new Address();
        address.setHiddenNames(obj.hiddenNames);
        address.setParameters(obj.parameters);
        address.setName(obj.name);
        address.url = obj.url;
        address.isRestored = true;
        return address;
    }
}